var map = {
	"./1.jpg": 908,
	"./2.jpg": 964,
	"./3.jpg": 749,
	"./4.jpg": 636,
	"./image1.jpg": 703,
	"./image2.png": 608,
	"./logo.png": 84,
	"./logo2.png": 80,
	"./logo3.png": 16,
	"./logo4.png": 548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;